import { render } from "./edb.vue?vue&type=template&id=527d6710&scoped=true"
import script from "./edb.vue?vue&type=script&lang=js"
export * from "./edb.vue?vue&type=script&lang=js"

import "./edb.vue?vue&type=style&index=0&id=527d6710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527d6710"]])

export default __exports__